const diff = (a, b) => {
  const bSet = new Set(b);
  return a.some(id => !bSet.has(id));
};
const buildChangeDescription = (hasChanges, flags) => {
  if (!hasChanges) {
    return 'No @mention changes.';
  }
  return [flags.teamAdded ? 'team added' : '', flags.teamRemoved ? 'team removed' : '', flags.userAdded ? 'user added' : '', flags.userRemoved ? 'user removed' : ''].filter(Boolean).join(' - ');
};
export const detectMentionChanges = (initial, current) => {
  const teamAdded = diff(current.teamIds, initial.teamIds);
  const teamRemoved = diff(initial.teamIds, current.teamIds);
  const userAdded = diff(current.userIds, initial.userIds);
  const userRemoved = diff(initial.userIds, current.userIds);
  const hasChanges = teamAdded || teamRemoved || userAdded || userRemoved;
  const changeDescription = buildChangeDescription(hasChanges, {
    teamAdded,
    teamRemoved,
    userAdded,
    userRemoved
  });
  return {
    hasChanges,
    changeDescription
  };
};
export const separateMentions = options => ({
  teamIds: options.filter(o => o.type === 'TEAM').map(o => String(o.value)),
  userIds: options.filter(o => o.type === 'OWNER').map(o => String(o.value))
});
export const processMentions = (mentions, allOptions, teamOptions) => {
  const teamIds = [];
  const userIds = [];
  const expandedUserIds = [];
  const optionMap = new Map();
  allOptions.forEach(opt => optionMap.set(String(opt.value), opt));
  const teamUserMap = new Map();
  teamOptions.forEach(team => {
    const allUserIds = [...(team.userIds || []), ...(team.secondaryUserIds || [])];
    if (allUserIds.length > 0) {
      teamUserMap.set(String(team.value), allUserIds);
    }
  });
  mentions.forEach(mentionValue => {
    const mentionKey = String(mentionValue);
    const option = optionMap.get(mentionKey);
    if ((option === null || option === void 0 ? void 0 : option.type) === 'TEAM') {
      teamIds.push(mentionKey);
      const memberUserIds = teamUserMap.get(mentionKey);
      if (memberUserIds) {
        expandedUserIds.push(...memberUserIds.map(String));
      }
    } else if ((option === null || option === void 0 ? void 0 : option.type) === 'OWNER') {
      userIds.push(mentionKey);
      expandedUserIds.push(mentionKey);
    }
  });
  return {
    separated: {
      teamIds,
      userIds
    },
    expanded: [...new Set(expandedUserIds)]
  };
};